<template>
  <div class="studylist">
    <tipheader :maxtitle="maxtitle" :mintitle="mintitle" :ifimg="ifimg" :width="'1.31'" :pathUrl="pathUrl" :linTxt='linTxt'></tipheader>
    <div class="alllist">
      <div class="signle" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
        <div class="title overfh" :title='item.compilationTitle'>
          {{ item.compilationTitle ||''}}
        </div>
        <div class="download" @click.stop="downloadFile(item)">立即下载</div>
      </div>
    </div>

  </div>

</template>

<script>

import tipheader from "../com/tipheader.vue";

export default {
  components: {
    tipheader,
  },
  props: ['sign','pathUrl','maxtitle','mintitle','ifimg','linTxt'],
  data: function () {
    return {
      list: [],
      signtype: '',
      pageNo: 1,
      pageSize: 10,
    };
  },

  mounted() {
    let params = {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    }
    this.signtype = this.sign + ''
    if (this.sign == 6) {//证书模板
      params.studyType = 4

    } 
    this.getDatalist(params)

  },

  methods: {
    goDetail(item){
      this.$router.push({path:'/downloadDetailbox',query:{id:item.id}})
    },
    downloadFile(item) {
      if(item.fileId_dictText||item.uploadType==1){ 
        if(item.uploadType==1){ 
          window.open(item.uploadHref)
        }else{ 
          window.open(this.$fileAccessHttpUrl(item.fileId_dictText))
        }
        
      }else{
        this.$message.success('没有附件')
      }
    },
    getDatalist(params) {///web/download/list
      this.$get('web/info/studyData', params).then(res => {
        if (res.success) {
          this.list = res.result.records
        }
      })
    },

  },


};
</script>

<style scoped=" scoped" lang="scss">

.studylist {

  .alllist {
    margin-top: 30px;
    min-height: 320px;

    .signle {
      display: flex;
      align-items: center;
      height: 40px;
      

      .title {
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        width: calc(100% - 130px);
        cursor: pointer;
      }

      .download {
        width: 120px;
        text-align: right;
        font-size: 18px;
        font-weight: 400;
        color: #E61F26;
        cursor: pointer;
      }
    }

    .signle:hover .title {
      color: #E61F26;
    }

  }


}

</style>
